import produce from 'immer';
import React from 'react';
import {
  getQuestionnaireById,
  getQuestionnaireByName,
} from '../../../apis/questionnaire';
import {
  IQuestionnaireContext,
  QuestionnaireContext,
} from '../../../contexts/questionnaire';
import { IQuestionnaire } from '../../../modules/unsw-fhir/Questionnaire';

export type QuestionnaireProviderProps = {
  questionnaireId?: string;
  quesionnaireName?: string;
};

export type QuestionnaireProviderState = IQuestionnaireContext;

export default class QuestionnaireProvider extends React.PureComponent<
  QuestionnaireProviderProps,
  QuestionnaireProviderState
> {
  constructor(props: QuestionnaireProviderProps) {
    super(props);

    this.state = {
      getQuestionnaireName: this.getQuestionnaireName,
      getQuestionnaireTitle: this.getQuestionnaireTitle,
      setQuestionnaire: this.setQuestionnaire,
    };
  }

  componentDidMount = async () => {
    return await this.updateQuestionnaire();
  };

  componentDidUpdate = async (pProps: QuestionnaireProviderProps) => {
    if (pProps.questionnaireId !== this.props.questionnaireId)
      return await this.updateQuestionnaire();
  };

  render = () => {
    return (
      <QuestionnaireContext.Provider value={this.state}>
        {this.props.children}
      </QuestionnaireContext.Provider>
    );
  };

  private getQuestionnaireName = () => {
    return (
      (this.state.questionnaire && this.state.questionnaire.name) || 'Unknown'
    );
  };

  private getQuestionnaireTitle = () => {
    return (
      (this.state.questionnaire && this.state.questionnaire.title) || 'Unknown'
    );
  };

  private setQuestionnaire = (Questionnaire: IQuestionnaire) => {
    return this.setState(state =>
      produce(state, draft => {
        draft.questionnaire = Questionnaire;
      }),
    );
  };

  private updateQuestionnaire = async () => {
    try {
      const { questionnaireId, quesionnaireName } = this.props;
      this.setState(state =>
        produce(state, draft => {
          draft.questionnaire = undefined;
          draft.loading = true;
        }),
      );

      const questionnaire = quesionnaireName
        ? await getQuestionnaireByName(quesionnaireName)
        : await getQuestionnaireById(questionnaireId);

      if (!questionnaire) {
        return this.setState(state =>
          produce(state, draft => {
            draft.questionnaire = questionnaire;
            draft.error = 'Questionnaire not found';
          }),
        );
      }

      this.setState(state =>
        produce(state, draft => {
          draft.questionnaire = questionnaire;
        }),
      );
    } catch (e) {
      this.setState(state =>
        produce(state, draft => {
          draft.questionnaire = undefined;
          draft.error = e as string | undefined;
        }),
      );
    } finally {
      this.setState(state =>
        produce(state, draft => {
          draft.loading = false;
        }),
      );
    }
  };
}
